import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/sitemap.xml')({
  loader: async () => {
    // Fetch all active markets for sitemap
    const markets = await fetch('https://skybit-api.botnet-599.workers.dev/markets?limit=1000')
      .then(r => r.json())
    
    const sitemap = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
  <url>
    <loc>https://skybit.bet</loc>
    <changefreq>hourly</changefreq>
    <priority>1.0</priority>
  </url>
  <url>
    <loc>https://skybit.bet/markets</loc>
    <changefreq>hourly</changefreq>
    <priority>0.9</priority>
  </url>
  ${markets.markets.map(market => `
  <url>
    <loc>https://skybit.bet/markets/${market.id}</loc>
    <lastmod>${new Date(market.updated_at).toISOString()}</lastmod>
    <changefreq>hourly</changefreq>
    <priority>0.8</priority>
  </url>`).join('')}
</urlset>`
    
    return new Response(sitemap, {
      headers: {
        'Content-Type': 'application/xml',
        'Cache-Control': 'public, max-age=3600' // Cache for 1 hour
      }
    })
  }
})